import React from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
import useVehicleBrandsLogic from "./useVehicleBrandsLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  { field: "name", label: "Name", allowSorting: true },
];

const VehicleBrandsPage = () => {
  const { addRoles, deleteRoles, editRoles, apiRoute, initFields } =
    useVehicleBrandsLogic();
  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to the Vehcile Brands." />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"vehicle_brand"}
        apiRoute={apiRoute}
        columns={columns}
        fields={initFields}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        enhancedTable={true}
      />
    </div>
  );
};

export default VehicleBrandsPage;
